import { AfterViewInit, Component, Injector, Input, Output, ElementRef, EventEmitter, OnInit, Renderer, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { GridService } from './grid.service';
import { GridComponent } from './grid.component';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
//import { PlaceHolderService } from '../modal/placeholder.service';
import { DataService } from '../../services/data/data.service';
import { ReportService } from '../../services/report/report.service';
import { PaginationService } from '../../services/pagination/pagination.service';
import { ReactiveformService } from '../../services/reactiveform/reactiveform.service';

@Component({
  selector: 'invoicegrid',
  template: '<grid></grid>',
  providers: [GenericdatasetService, GridService, PaginationService]
})

export class InvoiceGridComponent extends GridComponent {

  constructor(
    injector: Injector,
    public renderer: Renderer,
    public gridService: GridService,
    public itemService: GenericdatasetService,
    //public hotkeysService: HotkeysService,
    public dataService: DataService,
    public paginationService: PaginationService,
    public reactiveformService: ReactiveformService,
    public reportService: ReportService) {
    super(injector, renderer, gridService, itemService/*, hotkeysService*/, dataService, paginationService, reactiveformService);
  }

  public openItem(item: [any], parameters: any, templateNameRecord: string) {
    parameters['parentId'] = this.parentId;
    /*
    if (parameters['initValue']) {
      parameters['initValue'].push({ parentFieldName: 'tiers_id', parentId: 1000 });
    }
    */
    this.dataService.setStorage(parameters);
    super.openItem(item, parameters, templateNameRecord);
  }
}
